import { find, get } from "lodash"
import { createSelector } from "reselect"
import { percentageFormatter } from "helpers/formatters/numbers"
import { getMostUsedOrDefaultModelId } from "helpers/models"
import { UPLOAD_CONFIG } from "components/upload/constants"
import { getModels } from "resources/models"

const EMPTY_ARRAY = []
const EMPTY_OBJECT = {}

const getPortfolios = state => get(state, "global.data.portfolios.data", EMPTY_ARRAY)
const getRawScanResult = (state) => get(state, "modules.watchlistPositions.scanResult")
export const getWatchlist = state => get(state, "global.data.watchlist.data.watchlist")
export const getFiles = (state) => get(state, "modules.watchlistPositions.files")
export const getUploadedFiles = (state) => get(state, "modules.watchlistPositions.uploadedFiles")
export const getUploadOption = (state) => get(state, "modules.watchlistPositions.uploadOption")
export const getUploadDateTime = (state) => get(state, "modules.watchlistPositions.uploadDateTime")
export const getSelectedModel = (state) => get(state, "modules.watchlistPositions.modelId")
export const getAccount = state => get(state, "global.selected.account")
export const getUploadConfig = () => ({ ...UPLOAD_CONFIG })
export const getModel = createSelector(
  [getSelectedModel, getModels, getPortfolios, getWatchlist],
  (selectedModel, models, portfolios, watchlist) => {
    if (watchlist) {
      if (selectedModel) return selectedModel

      return getMostUsedOrDefaultModelId(portfolios, models)
    }

    return null
  },
)

export const getWatchlistDetails = createSelector(
  [getWatchlist, getModel, getModels],
  (watchlist, modelId, models) => {
    if (watchlist) {
      return ({
        id: watchlist.id,
        name: watchlist.name,
        modelId,
        model: get(find(models, { id: modelId }), "name"),
        count: watchlist.count,
      })
    }

    return null
  },
)

export const getScanResult = createSelector(
  [getRawScanResult],
  (scanResult) => {
    if (scanResult) {
      const scanSummary = get(scanResult, "scan.summary", EMPTY_OBJECT)
      return {
        ...scanResult,
        summary: {
          items: {
            modelCoverage: {
              label: "Model Coverage",
              value: percentageFormatter(scanSummary.percentModeled / 100),
            },
            numberSecurities: {
              label: "Securities found",
              value: scanSummary.numberSecurities,
            },
            unmappedSecurities: {
              label: "Unmapped Securities",
              value: scanSummary.unmappedSecurities,
            },
          },
        },
      }
    }

    return null
  },
)
